import React from "react";
import { WarningIcon } from "../../../../components/icons";
import { MotionModal, ModalCloseButton } from "../../../../components/motion";

const ErrorModal = ({
    text = "An error occurred. Please try again.",
    handleClose,
    show,
}) => {
    return (
        <MotionModal
            show={show}
            onClose={handleClose}
            maxWidthClassName="tw:max-w-lg"
            panelClassName="tw:border-t-4 tw:border-red-500"
        >
            <ModalCloseButton onClick={handleClose} />
            <div className="tw:p-6 tw:text-center">
                <div className="tw:mb-4">
                    <WarningIcon width={64} height={64} color="#ED553B" />
                </div>
                <div className="tw:text-red-500 tw:text-xl tw:font-medium">
                    {text}
                </div>
            </div>
        </MotionModal>
    );
};

export default ErrorModal;
